interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function Card({
  children,
  className = '',
  onClick,
}: CardProps): JSX.Element {
  const Component = onClick ? 'button' : 'div';
  const interactiveClasses = onClick ? 'cursor-pointer hover:bg-gray-50' : '';

  return (
    <Component
      type={onClick ? 'button' : undefined}
      className={`rounded-lg border border-[#D9D9D9] bg-[#FEFDFC]  px-3 py-2 ${interactiveClasses} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </Component>
  );
}
